import { useMemo } from 'react';
import { useSelector } from 'umi';
import { timeZoneTransformForShow} from "@/pages/dashboard/utils/utils";

const useSelectorDataNew = (timezoneType) => {
  const { selector, selectorLoading } = useSelector(state => {
    // @ts-ignore
    const { loading, dashboardSetting: { selector } } = state;
    return {
      selector,
      selectorLoading: loading.effects['dashboardSetting/getSelector'],
    }

  });
  
  // 获取selector
  const selectorList = useMemo(() => {
    // 多时区页面刷新时, 还没有请求newSelector接口, selectorLoading是undefined, 所以需要返回null, 让筛选器内部请求newSelector接口.
    if (selectorLoading || selectorLoading === undefined) return null
    // 多时区页面需要根据 不同的时区类型, 在筛选器选项中拼接 (UTC+8)文本.
    const getTextWithUtc = (arr, prefix) => {
      return arr.map(item => {
        if (!item?.deviation) return {...item};
        const timezone = timeZoneTransformForShow(item?.deviation);
        return {
          ...item,
          [`${prefix}_ch`]: item?.[`${prefix}_ch`] + " (" + timezone + ")",
          [`${prefix}_en`]: item?.[`${prefix}_en`] + " (" + timezone + ")"
        }
      })
    }
    const newSelector = {...selector};
    if (timezoneType === "zone") {
      newSelector.zone_list = getTextWithUtc(selector?.zone_list || [], 'zone_name')
    } else if (timezoneType === "country") {
      newSelector.key_country_list = getTextWithUtc(selector?.key_country_list || [], 'country_name')
      newSelector.area_list = selector?.area_list?.map(item => {
        
        return {
          ...item,
          country_set: getTextWithUtc(item?.country_set || [], 'country_name')
        }
      });
    }
    return newSelector;
  }, [selectorLoading, timezoneType]);

  return {
    selectorLoading,
    selectorData: selectorList
  }
}
export default useSelectorDataNew;